<template id="question-commodity-setup">
    <li>
        <!-- <div class="info">question-custom-choices</div> -->
        <div v-html="question" class="question"></div>
        <div v-if="subtype=='iconbuttons'" class="btn-container">
            <button  class="iconbutton" v-for="( choice, i ) in choices" :key="i" :id="'commodity_'+lowerize(choices[i])" @click="updateValue( index, i+1 )"
                :class="[ value==i+1 ? 'active' : '' ]">

                <div v-if="icons[i]!='icon-dual'" class="icon-cont">
                    <span class="icon" :class="icons[i]"></span>
                </div>
                <div v-if="icons[i]=='icon-dual'" class="icon-cont">
                    <span class="icon icon-lampadina"></span>
                    <span class="text-min">+</span>
                    <span class="icon icon-gas"></span>
                </div> 

                <div class="text">{{ choice }}</div>
            </button>
        </div>

        <div v-else-if="subtype=='normal'" class="btn-container">
            <button class="longbutton" v-for="( choice, i ) in choices" :key="i" :id="'commodity_'+lowerize(choices[i])" @click="updateValue( index, i )"
                :class="[ value==i ? 'active' : '' ]">
                <div class="text">{{ choice }}</div>
            </button>
        </div>
    </li>
</template>

<script>
export default {
    template: '#question-commodity-setup',

    props: ['question', 'index', 'choices', 'icons', 'subtype', 'preselection', 'trackingclass'],
    data: function () {
        return {
            value: -1
        };
    },

    created: function () {
        this.value = -1;
    },
    beforeMount: function () {
        this.value = -1;
    },

    mounted: function () {
        //this.preselectionId = "commodity_" + this.preselection.toLowerCase().replace(/\s+/g, '');
        //document.getElementById(this.preselectionId).click();
    },

    methods: {
        updateValue: function (index, val) {
            console.log('choice >', this.choices[val-1]);
            console.log('updateValue', index, val);
            this.value = val;
            this.$emit('update-value', [index, val]);
        },

        lowerize: function (val) {
            val = val.toLowerCase().replace(/\s+/g, '');
            return val;
        },
    }
}
</script>